<template>
    <div>
        <footer class="main-footer">
            <strong>Copyright &copy; 2014-2019 <a href="http://adminlte.io">AdminLTE.io</a>.</strong>
            All rights reserved.
            <div class="float-right d-none d-sm-inline-block">
                <b>Version</b> 3.0.4
            </div>
            <a href="https://buymeacoffee.com/hbakouane">
                <img class="img-fluid rounded-pill border" style="height: 70px;" src="https://influencermarketinghub.com/wp-content/uploads/2021/03/skiptheflip_buymeacoffee3_creativeworkdonations.png">
            </a>
        </footer>
    </div>
</template>

<script>
export default {
    name: "Footer"
}
</script>